// extracted by mini-css-extract-plugin
module.exports = {"orderSim":"ordersim_orderSim__2fW0J","titleWrapper":"ordersim_titleWrapper__2pt4F","title":"ordersim_title__31JhG"};